import Typography from "components/typography";
import { useClickOutside } from "hooks/UseClickOutside";
import React, { useRef } from "react";
import styled from "styled-components";
import { Colors } from "utils/colors";

interface IProps {
  type: "Artist" | "Writer" | "Contributor";
  deleteItem: () => void;
  editItem: () => void;
  setActive: (bool: boolean) => void;
}
const ItemOption = ({
  type = "Artist",
  deleteItem,
  editItem,
  setActive
}: IProps) => {
  const ref = useRef(null);

  useClickOutside(ref, () => {
    setActive(false);
  });

  return (
    <Container ref={ref}>
      <Item
        onClick={() => {
          editItem();
          setActive(false);
        }}
      >
        <ItemIcon>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="100%"
            height="100%"
            viewBox="0 0 16 16"
            fill="none"
          >
            <path
              d="M9.3201 3.56396L9.83911 3.0449C10.6991 2.1849 12.0935 2.1849 12.9534 3.0449C13.8134 3.90489 13.8134 5.29922 12.9534 6.15922L12.4344 6.67827M9.3201 3.56396C9.3201 3.56396 9.38495 4.66694 10.3582 5.64017C11.3314 6.61339 12.4344 6.67827 12.4344 6.67827M9.3201 3.56396L4.54818 8.33586C4.22497 8.65909 4.06336 8.82065 3.92438 8.99884C3.76043 9.20907 3.61988 9.43648 3.50519 9.67711C3.40797 9.88112 3.3357 10.098 3.19115 10.5316L2.57865 12.3691M12.4344 6.67827L7.6625 11.4502C7.33927 11.7734 7.17771 11.935 6.99952 12.074C6.7893 12.2379 6.56187 12.3785 6.32123 12.4932C6.11723 12.5904 5.90041 12.6626 5.46678 12.8072L3.62927 13.4197M2.57865 12.3691L2.42893 12.8183C2.3578 13.0316 2.41333 13.2669 2.57239 13.426C2.73145 13.585 2.96671 13.6406 3.18011 13.5695L3.62927 13.4197M2.57865 12.3691L3.62927 13.4197"
              stroke="#E8E8E8"
              stroke-width="0.980001"
            />
          </svg>
        </ItemIcon>
        <Typography color={Colors.grey200} m_size="xs">
          Edit {type}
        </Typography>
      </Item>
      <Item
        onClick={() => {
          deleteItem();
          setActive(false);
        }}
      >
        <ItemIcon>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="100%"
            height="100%"
            viewBox="0 0 16 16"
            fill="none"
          >
            <path
              d="M13.6654 4H2.33203"
              stroke="#E8E8E8"
              stroke-linecap="round"
            />
            <path
              d="M12.5564 5.6665L12.2498 10.2659C12.1318 12.0358 12.0728 12.9208 11.4961 13.4603C10.9194 13.9998 10.0325 13.9998 8.25865 13.9998H7.74311C5.96921 13.9998 5.08228 13.9998 4.50561 13.4603C3.92894 12.9208 3.86994 12.0358 3.75194 10.2659L3.44531 5.6665"
              stroke="#E8E8E8"
              stroke-linecap="round"
            />
            <path
              d="M6.33203 7.3335L6.66536 10.6668"
              stroke="#E8E8E8"
              stroke-linecap="round"
            />
            <path
              d="M9.66536 7.3335L9.33203 10.6668"
              stroke="#E8E8E8"
              stroke-linecap="round"
            />
            <path
              d="M4.33203 4C4.36928 4 4.38791 4 4.4048 3.99957C4.95376 3.98566 5.43804 3.63661 5.62484 3.12021C5.63059 3.10433 5.63648 3.08666 5.64826 3.05131L5.71298 2.85714C5.76824 2.69139 5.79586 2.60851 5.8325 2.53813C5.9787 2.25738 6.24919 2.06243 6.56177 2.01251C6.64012 2 6.7275 2 6.90223 2H9.09516C9.2699 2 9.3573 2 9.43563 2.01251C9.74823 2.06243 10.0187 2.25738 10.1649 2.53813C10.2016 2.60851 10.2292 2.69139 10.2844 2.85714L10.3492 3.05131C10.3609 3.08661 10.3668 3.10434 10.3726 3.12021C10.5594 3.63661 11.0436 3.98566 11.5926 3.99957C11.6095 4 11.6281 4 11.6654 4"
              stroke="#E8E8E8"
            />
          </svg>
        </ItemIcon>
        <Typography color={Colors.grey200} m_size="xs">
          Remove {type}
        </Typography>
      </Item>
    </Container>
  );
};

export default ItemOption;

const Container = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  padding: 1.2rem;
  background-color: ${Colors.grey1000};
  border-radius: 0.8rem;
  display: grid;
  grid-template-columns: 19rem;
  grid-row-gap: 0.8rem;
  z-index: 5;
`;

const Item = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  padding: 1.2rem 1.6rem;
  border-radius: 0.6rem;
  cursor: pointer;
  transition: all ease-in 0.1s;
  &:hover {
    background-color: ${Colors.grey900};
  }
`;
const ItemIcon = styled.div`
  width: 1.6rem;
  height: 1.6rem;
  margin-right: 0.8rem;
`;
